import type IsoDate from '../../../models/IsoDate';
import type StudyParticipantModel from '../../../models/StudyParticipantModel';
import { requestAndParse, requestSuccessful } from '../request';

const createStudyParticipant = async (
    studyId: number,
    userId: number,
    startDate: IsoDate,
    participantId: string,
) => {
    const route = 'admin/create-study-participant';
    const payload = {
        studyId,
        userId,
        startDate,
        participantId,
    };

    const response = await requestAndParse(route, payload, 'POST');

    const success = requestSuccessful(response);
    const studyParticipant = (response.body?.participant ??
        {}) as StudyParticipantModel;

    return { success, studyParticipant };
};

export default createStudyParticipant;
